if(ID.userIcon2menu) addEventListener("DOMContentLoaded", _=> {
    let breaker = parseInt(FN.getCSSVar(document.body, "--break-lg-end"));
    let anchor = document.querySelector(".navmenu-user");
    let div = ID.userIcon2menu;
    let handler = _=> {
        div.style.top = (anchor.offsetTop + 56) + "px";
        if(document.body.offsetWidth < breaker) {
            div.style.right = "8px";
            div.style.removeProperty("left");
        }
        else {
            div.style.left = (anchor.offsetLeft - 250 + 48 + 56) + "px"; // 48, 56 = šířka ikon
            div.style.removeProperty("right");
        }
    }

    anchor.onclick = handler;
});